<script setup lang="ts">
import { onMounted } from 'vue';
const Logout = () => {
  
  sessionStorage.clear();
  console.log("로그아웃 완료, 사용자 상태 초기화");
  window.location.href = '/';
}

onMounted(() => {
  Logout();
});
</script>

<template></template>